/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Define entire application timeout intervals
 */
const TIME_OUTS = {
  REDIRECT_TO_LOGIN: 5,
  SESSION_OBSERVER_TIME: 5000,
  TIME_INTERVAL_FOR_PING_SQL_WAREHOUSE: 1800000,
  NOTIFICATION_INTERVAL: 60000,
  ACCESS_TOKEN_REFRESH_LEEWAY: 10,
  REFRESH_TOKEN_RETRY_DELAYS: [1000, 2000, 5000], // 1s, 2s, 5s
};
//
export default TIME_OUTS;
